import "./styles.scss";

import { useState } from "react";

import LanguageFlag from "../LanguageFlag";
import lingoIcon from "../../../assets/images/lingo_small.png";

const ProfileField = ({ label, avatarUrl, defaultValue, inputId }) => {
  const [value, setValue] = useState(defaultValue);

  return (
    <div className="lessonHeader__profile">
      <img src={avatarUrl} alt={label} className="lessonHeader__profileAvatar" />
      <span className="lessonHeader__profileLabel">{label}:</span>
      <input
        id={inputId}
        type="text"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        className="lessonHeader__profileInput"
      />
    </div>
  );
};

const LessonHeader = ({ lessonHeaderCard, participantsCard, onHomeClick }) => {
  const { title, subtitle, badge, targetLanguage } = lessonHeaderCard;
  const teacher = participantsCard?.teacher;
  const student = participantsCard?.students?.[0];

  return (
    <header className="lessonHeader">
      <div className="lessonHeader__inner">
        <div className="lessonHeader__identity">
          <button type="button" className="lessonHeader__homeBtn" onClick={onHomeClick} aria-label="Home">
            <img src={lingoIcon} alt="Lingo" />
          </button>
          <div>
            <h1 className="lessonHeader__title">
              {title}
              {badge && <span className="lessonHeader__badge">{badge}</span>}
              <LanguageFlag locale={targetLanguage?.locale} />
            </h1>
            <p className="lessonHeader__subtitle">{subtitle}</p>
          </div>
        </div>

        <div className="lessonHeader__profiles">
          {teacher && (
            <ProfileField
              label="Teacher"
              avatarUrl={teacher.avatarUrl}
              defaultValue={teacher.displayName}
              inputId="field-rc-teacher-name"
            />
          )}
          {student && (
            <ProfileField
              label="Student"
              avatarUrl={student.avatarUrl}
              defaultValue={student.displayName}
              inputId="field-rc-student-name"
            />
          )}
        </div>
      </div>
    </header>
  );
};

export default LessonHeader;
